import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { BibleVersionManager } from "@/features/admin/components/bible-version-manager";
import { PageContainer } from "@fleet/ui";

function AdminBibleVersionsPage() {
  return (
    <PageContainer maxWidth="6xl">
      <BibleVersionManager />
    </PageContainer>
  );
}

export const adminBibleVersionsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/bible-versions",
  component: AdminBibleVersionsPage,
});
